module.exports = __webpack_public_path__ + "static/img/app.5ab8714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/app.png
// module id = ffuG
// module chunks = 0